/** Pulls the backend's actual message out of an axios error, instead of surfacing
 * generic wire-protocol text like "Request failed with status code 409". */
export function getErrorMessage(err: unknown, fallback = 'Something went wrong.'): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const response = (err as { response?: { data?: { message?: string | string[] } } }).response;
    const message = response?.data?.message;
    if (Array.isArray(message)) return message.join(', ');
    if (message) return message;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
